<small class="debug">{{me}}</small>

<!--------------------------------------------------- -->
<!-- example of dynamic loading a component in non lazy fashion via suspense mode -->
<!-- https://netbasal.com/adding-suspense-to-angular-%EF%B8%8F-%EF%B8%8F-1f34fd603584 -->
<!-- https://github.com/born2net/ng-suspense -->
<!--------------------------------------------------- -->


<!--------------------------------------------------- -->
<!-- static loading of included component -->
<!--------------------------------------------------- -->
<!--<suspense>-->
<!--    <station-non-lazy-sample></station-non-lazy-sample>-->
<!--    <ng-template fallbackView>-->
<!--        <span>loading component...</span>-->
<!--    </ng-template>-->
<!--</suspense>-->
<!--<hr/>-->

<!--------------------------------------------------- -->
<!-- dynamic loading of external file component -->
<!--------------------------------------------------- -->
<suspense>
    <ng-template [defaultView]="usersFactory"></ng-template>
    <ng-template errorView>
        <mat-icon>block</mat-icon>
        <h4>problem loading data :(</h4>
    </ng-template>
    <ng-template fallbackView>
        <br/>
        <br/>
        <br/>
        <app-loading></app-loading>
        <!-- <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>-->
    </ng-template>
</suspense>



